import React from "react";
import Slider from "react-slick";
import utils from "../../common/utils";
import { useNavigate } from "react-router-dom";
import sliderJson from "../../../apiData/slider.json";

import {
  MainDiv,
  BgBlob,
  DotGrid,
  Wave2,
  MainContainer,
  Container0,
  Container2,
  Container4,
  Hi,
  Name,
  NameDivider,
  Profession,
  Testimonial,
  PhotoContainer,
  SpinRing,
  SpinRingAccent,
  PhotoGlow,
  Photo1,
  SliderBtn,
} from "./SliderComponent.styles";

// ─── Icons ────────────────────────────────────────────────────────────────────
const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden="true">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

// ─── Single Slide ─────────────────────────────────────────────────────────────
const SlideItem = ({ value, index, onContact }) => {
  const isHero = index === 0;

  return (
    <MainContainer>
      <Container0>

        {/* ── Text Side ── */}
        <Container2>
          <Container4>
            {isHero ? (
              <Hi>✦ Hi, I'm</Hi>
            ) : (
              <Hi>✦ Meet Our Expert</Hi>
            )}

            <Name>{value?.name}</Name>
            <NameDivider aria-hidden="true" />
            <Profession>{value?.profession}</Profession>

            <Testimonial>
              {utils.getShortDesc(value?.comments)}
            </Testimonial>

            {!isHero && (
              <SliderBtn
                type="button"
                onClick={onContact}
                aria-label={`Request a free consultation with ${value?.name}`}
              >
                Request a Free Consultation <ArrowIcon />
              </SliderBtn>
            )}
          </Container4>
        </Container2>

        {/* ── Photo Side ── */}
        <PhotoContainer aria-hidden="true">
          <SpinRingAccent />
          <SpinRing />
          <PhotoGlow />
          <Photo1
            src={value?.image}
            alt={value?.name}
            loading="lazy"
          />
        </PhotoContainer>

      </Container0>
    </MainContainer>
  );
};

// ─── Slider Settings ──────────────────────────────────────────────────────────
const sliderSettings = {
  infinite: true,
  slidesToShow: 1,
  lazyLoad: true,
  autoplay: true,
  autoplaySpeed: 5000,
  dots: true,
  swipeToSlide: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true, dots: true },
    },
    {
      breakpoint: 600,
      settings: { slidesToShow: 1, slidesToScroll: 1, initialSlide: 0 },
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 1, slidesToScroll: 1 },
    },
  ],
  afterChange: (index) => {
    console.log(`Slider Changed to: ${index + 1}`);
  },
};

// ─── SliderComponent ──────────────────────────────────────────────────────────
function SliderComponent() {
  const navigate   = useNavigate();
  const onContact  = React.useCallback(() => navigate("/contactUs"), [navigate]);

  return (
    <MainDiv>
      <BgBlob className="s1" aria-hidden="true" />
      <BgBlob className="s2" aria-hidden="true" />
      <BgBlob className="s3" aria-hidden="true" />
      <DotGrid aria-hidden="true" />

      <Slider {...sliderSettings}>
        {sliderJson?.map((item, i) => (
          <SlideItem
            key={item.id ?? i}
            value={item}
            index={i}
            onContact={onContact}
          />
        ))}
      </Slider>

      {/* <Wave2 aria-hidden="true" /> */}
    </MainDiv>
  );
}

SliderComponent.displayName = "SliderComponent";
export default React.memo(SliderComponent);